import styled from 'styled-components';

import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceM,
  spaceXS,
  xdlColorHover,
  xdlColorText,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledContainer = styled.a`
  flex-direction: column;
  align-items: center;
  display: flex;
  padding: ${spaceL};
  color: ${xdlColorText};

  &:hover {
    background-color: ${xdlColorHover};
    text-decoration: none;
  }

  @media ${mediaConfined} {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  margin-bottom: ${spaceM};

  @media ${mediaConfined} {
    max-width: 65%;
  }

  @media ${mediaWideNavless} {
    max-width: 75%;
  }
`;

export const StyledUserData = styled.div`
  margin-left: ${spaceM};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXS};
`;

export const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceXS};
`;
